export default {
  'page.userCenter.orderDetail': '订单详情',
  'page.userCenter.myOrder': '我的订单',
};
